//
import { ModuleLayout } from '@/components/reusable_components/next'
import { PromosCreate, PromosList, PromosUpdate } from '@/views/promos'
import CreatePromoMainTab from '@/views/promos/newPromoTab/create/CreateMain.vue'
import UpdatePromoMainTab from '@/views/promos/newPromoTab/showEdit/ShowEditMain.vue'
//
export default {
    path: 'promos',
    component: ModuleLayout,
    children: [
        {
            path: 'create',
            name: 'promos_create',
            component: CreatePromoMainTab,
            meta: {
                title: 'Crear promoción'
            },
        },
        {
            path: '',
            name: 'promos_list',
            component: PromosList,
        },
        {
            path: ':id',
            name: 'promos_show',
            component: UpdatePromoMainTab,
            meta: {
                title: 'Detalles de la promoción'
            },
        },
    ],
    meta: {
        title: 'Promociones'
    },
}